import React, { useState } from "react";
import { Monitor, Mobile, SliderVertical1 } from "iconsax-react";
import Button from "./Button";

const PreviewHeader = ({ onViewChange, data, recordId, type, onClose }) => {
  const [viewStates, setViewStates] = useState({
    monitor: true,
    tablet: false,
    mobile: false,
  });

  const views = [
    { id: "monitor", icon: <Monitor size="24" />, label: "Desktop" },
    { id: "tablet", icon: <SliderVertical1 size="24" />, label: "Tablet" },
    { id: "mobile", icon: <Mobile size="24" />, label: "Mobile" },
  ];

  const handleViewChange = (selectedId) => {
    setViewStates((prevState) => {
      const updatedState = Object.keys(prevState).reduce((acc, key) => {
        acc[key] = key === selectedId;
        return acc;
      }, {});
      return updatedState;
    });
    onViewChange(selectedId); // Notify parent component of the change
  };

  return (
    <div className="flex sticky top-0 z-10 w-full h-[80px] max-h-[80px] items-center justify-between bg-white px-[32px] border-b border-[#EFF0F2]">
      {/* Preview Title */}
      <div className="text-lg font-medium flex w-full items-center justify-start gap-[16px]">
        Preview
      </div>

      {/* View Button */}
      <div className="flex w-full items-center justify-center gap-[16px]">
        {views.map((view) => (
          <div key={view.id} className="relative flex flex-col items-center">
            <button
              onClick={() => handleViewChange(view.id)}
              className={`flex items-center justify-center w-[40px] h-[40px] rounded ${
                viewStates[view.id] ? "bg-gray-200" : ""
              }`}
            >
              {view.icon}
            </button>
            {viewStates[view.id] && (
              <div className="absolute bottom-[-6px] left-1/2 transform -translate-x-1/2 w-[6px] h-[6px] bg-black rounded-full" />
            )}
          </div>
        ))}
      </div>

      {/* Close Button */}
      <div className="flex w-full items-center justify-end">
        <div className="">
          <Button
            variant="secondary"
            onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PreviewHeader;
